import { render, staticRenderFns } from "./BindAccountRolePopPDD.vue?vue&type=template&id=e4bc38d2&"
import script from "./BindAccountRolePopPDD.vue?vue&type=script&lang=js&"
export * from "./BindAccountRolePopPDD.vue?vue&type=script&lang=js&"
import style0 from "./BindAccountRolePopPDD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports